
import Navbar from "../global/Navbar";
import HomeBanner from "../components/Home/HomeBanner";
import Features from "../components/Home/Features";
import Questions from "../components/Home/Questions";
import FeatureValue from "../components/Home/FeatureValue";
import FeatureValue1 from "../components/Home/FeatureValue1";
import FeatureValue2 from "../components/Home/FeatureValue2";
import Testimonial from "../components/Home/Testimonial";
import Counter from "../components/Home/Counter";
import Video from "../components/Home/Video";
import Program from "../components/Home/Program";


const Home = () => {
  
  return (
    <>
    
    <div className="home-banner flex flex-col bg-[#101e2b] px-4 lg:px-0">
      <Navbar />
       <HomeBanner/>
    </div>

    <FeatureValue/>
    <FeatureValue1/>
    <FeatureValue2/>
    <Program/>
    <Testimonial/>
    <Features/>
    <Video/>
    <Counter/>
    <Questions/>
    
    
    </>
  );
};

export default Home;
